module.exports = __webpack_public_path__ + "static/media/information_Partner_1.0.cdec0288.md";